var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c(_vm.component,_vm._b({tag:"component"},'component',{ blogId: _vm.blogId },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }